export const sendMessage = (message) => {
    let parentOrigin = '';

    try {
        if (document.referrer) {
            parentOrigin = new URL(document.referrer).origin;
        }
        else if (window.location.href) {
            parentOrigin = new URL(window.location.href).origin;
        }
        const allowedOriginPattern = /^https?:\/\/([a-zA-Z0-9-]+\.)*hostelworld\.com$/;
        if (parentOrigin && parentOrigin.match(allowedOriginPattern)) {
            parent.postMessage(message, parentOrigin);
        } else {
            console.warn("Blocked postMessage: Invalid target origin");
        }
    } catch (error) {
        console.warn("Error in onClickReadMore: Invalid URL");
    }
}